import { Component, OnInit, Input } from '@angular/core';
import { Dog } from 'src/app/shared/models/dog';

@Component({
  selector: 'app-dog-details',
  templateUrl: './dog-details.component.html',
  styleUrls: ['./dog-details.component.css']
})
export class DogDetailsComponent implements OnInit {

  @Input() model: Dog;

  constructor() { }

  ngOnInit() {
  }

}
